<template>
  <transition name="modal-fade">
    <div v-if="value" class="modal-backdrop" @click.self="closeOnBackdropClick">
      <div class="modal" tabindex="-1" role="dialog" style="display: block">
        <div class="modal-dialog" :class="modalSizeClass" role="document">
          <div class="modal-content pb-2 align-items-center">
            <!-- <div class="modal-header">
              <slot name="header">
                <h5 class="modal-title">{{ title }}</h5>
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </slot>
            </div> -->

            <div class="modal-body">
              <slot>
                <p class="errModalTitle">{{ title }}</p>
              </slot>
            </div>
            <button type="button" class="btn errModalCloseBtn" @click="close"
              >Close</button
            >
            <!-- <div class="modal-footer">
              <slot name="footer">
               
              </slot>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ErrorModal",
  props: {
    // Use v-model to control the visibility of the modal
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "Modal Title",
    },
    // Optional size prop: 'sm', 'lg', 'xl'
    size: {
      type: String,
      default: null,
      validator: (val) => ["sm", "lg", "xl"].includes(val),
    },
    // Whether to close the modal when clicking on the backdrop
    closeOnBackdrop: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    modalSizeClass() {
      return this.size ? `modal-${this.size}` : "";
    },
  },
  methods: {
    close() {
      // Emitting 'input' with false allows v-model to work
      this.$emit("input", false);
      // Emit a 'close' event for more explicit event handling if needed
      this.$emit("close");
      this.$router.go(-1);
    },
    closeOnBackdropClick() {
      if (this.closeOnBackdrop) {
        this.close();
      }
    },
    handleEscapeKey(event) {
      if (event.key === "Escape" && this.value) {
        this.close();
      }
    },
  },
  mounted() {
    // Add event listener for the Escape key to close the modal
    document.addEventListener("keydown", this.handleEscapeKey);
  },
  beforeDestroy() {
    // Clean up the event listener when the component is destroyed
    document.removeEventListener("keydown", this.handleEscapeKey);
  },
};
</script>

<style scoped>
.errModalCloseBtn {
  color: #fff;
  background-color: #cc0000;
  width: 120px;
}
.errModalTitle {
  color: #000;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin: 0px;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  opacity: 1 !important;
}

.modal {
  /* We override Bootstrap's display:none with display:block */
  /* to allow Vue to control visibility */
  position: relative;
  outline: 0;
}

/* --- Transition Styles --- */
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/errorModal.vue